const autocompleteModalFilterEquip = {
  maintenance: 'Equipos en mantenimiento',
  valid: 'Equipos aptos para uso',
  validWithOpenedActions: 'Equipos aptos en adecuación',
  inactive: 'Equipos inactivos',
  invalid: 'Equipos no aptos para uso',
  inDelay: 'Servicios vencidos',
  notDone: 'Servicios obligatorios no realizados',
  hasActionsOpenedOrOverdue: 'Servicios con acciones abiertas o vencidas',
  hasNoServices: 'No tiene ningún servicio',
  mixed: 'Motivos diversos'
};

export default autocompleteModalFilterEquip;
